"use strict";
function _createForOfIteratorHelper(r, e) {
  var t;
  if ("undefined" == typeof Symbol || null == r[Symbol.iterator]) {
    if (
      Array.isArray(r) ||
      (t = _unsupportedIterableToArray(r)) ||
      (e && r && "number" == typeof r.length)
    ) {
      t && (r = t);
      var n = 0,
        o = function () {};
      return {
        s: o,
        n: function () {
          return n >= r.length ? { done: !0 } : { done: !1, value: r[n++] };
        },
        e: function (r) {
          throw r;
        },
        f: o,
      };
    }
    throw new TypeError(
      "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
    );
  }
  var a,
    i = !0,
    u = !1;
  return {
    s: function () {
      t = r[Symbol.iterator]();
    },
    n: function () {
      var r = t.next();
      return (i = r.done), r;
    },
    e: function (r) {
      (u = !0), (a = r);
    },
    f: function () {
      try {
        i || null == t.return || t.return();
      } finally {
        if (u) throw a;
      }
    },
  };
}
function _unsupportedIterableToArray(r, e) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    return (
      "Object" === t && r.constructor && (t = r.constructor.name),
      "Map" === t || "Set" === t
        ? Array.from(r)
        : "Arguments" === t ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
        ? _arrayLikeToArray(r, e)
        : void 0
    );
  }
}
function _arrayLikeToArray(r, e) {
  (null == e || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++) n[t] = r[t];
  return n;
}
var updateComma = function () {
  var r = document.querySelectorAll(".sq-product-price-feature");
  if (r && r.length) {
    var e,
      t = _createForOfIteratorHelper(r);
    try {
      for (t.s(); !(e = t.n()).done; ) {
        var n,
          o,
          a = e.value,
          i = a.querySelector(".sq-price"),
          u = a.querySelector(".sq-compare-price");
        !i ||
          (-1 < (n = i.innerText).indexOf(".") &&
            (i.innerText = n.replace(".", ","))),
          !u ||
            (-1 < (o = u.innerText).indexOf(".") &&
              (u.innerText = o.replace(".", ",")));
      }
    } catch (r) {
      t.e(r);
    } finally {
      t.f();
    }
  }
};
(window.sq = window.sq || {}),
  (window.sq.onComplete = function (r) {
    changeSearchURL();
    updateComma();
  });

function changeSearchURL() {
  setTimeout(() => {
    let anchor = document.querySelector("#sparq-dd a.btn-blue");
    if (anchor) {
      let href = anchor.href;
      href = href.replace("pages/search-results", "search");
      anchor.href = href;
    }
  });
}

// (window.sq = window.sq || {}),
//   (window.sq.onComplete = function (r) {
//     updateComma();
//   });
